import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=a60db858&scoped=true&"
import script from "./Connect.vue?vue&type=script&lang=js&"
export * from "./Connect.vue?vue&type=script&lang=js&"
import style0 from "./Connect.vue?vue&type=style&index=0&id=a60db858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60db858",
  null
  
)

export default component.exports